class CardHoverImage extends HTMLElement {
  #abort;

  connectedCallback() {
    this.#abort?.abort();
    this.#abort = new AbortController();
    const card = this.closest('product-card');
    if (!card) return;
    const { signal } = this.#abort;
    card.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'touch' && matchMedia('(hover: hover) and (pointer: fine)').matches) this.#load();
    }, { signal });
    card.addEventListener('focusin', (event) => {
      if (event.target instanceof Element && event.target.matches(':focus-visible')) this.#load();
    }, { signal });
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }

  #load() {
    const template = this.querySelector('template');
    if (template) {
      this.append(template.content.cloneNode(true));
      template.remove();
    }
    const image = this.querySelector('img');
    if (!image) return;
    const ready = () => this.toggleAttribute('data-ready', image.naturalWidth > 0);
    if (image.complete) ready();
    else image.addEventListener('load', ready, { once: true, signal: this.#abort.signal });
  }
}
if (!customElements.get('cgl-card-hover-image')) customElements.define('cgl-card-hover-image', CardHoverImage);
